import classNames from 'classnames'
import {memo} from 'react'

import {stringifyId} from '../../../../../../../../types'
import styles from '../../../../../../../common/Sidebar/SidebarItem/SidebarItem.css'
import type {VirtualizedTreeChildProps} from '../../../../../../../common/VirtualizedTree/VirtualizedTree'
import VirtualizedTreeItem from '../../../../../../../common/VirtualizedTree/VirtualizedTreeItem/VirtualizedTreeItem'
import VirtualizedTreeOverlayItem from '../../../../../../../common/VirtualizedTree/VirtualizedTreeOverlayItem/VirtualizedTreeOverlayItem'
import type {QueueSidebarItemType} from '../../../QueueSidebar.types'
import QueueSidebarLinkItem from '../QueueSidebarLinkItem/QueueSidebarLinkItem'
import QueueSidebarPoolItem from '../QueueSidebarPoolItem/QueueSidebarPoolItem'

type Props = VirtualizedTreeChildProps<QueueSidebarItemType>

function QueueSidebarItem(props: Props) {
  switch (props.item.type) {
    case 'queue-sidebar-pool': {
      const {item, ...restProps} = props
      const {id, title, type, active, counters} = item
      return (
        <VirtualizedTreeOverlayItem
          className={classNames(styles.item, styles.hoverableItem)}
          activeClassName={classNames(styles.activeItem, styles.activeTitle)}
          hoveredClassName={styles.hoveredItem}
          focusedClassName={styles.focusedItem}
          wrapperClassName={styles.itemWrapper}
          active={active}
          expandable={false}
          itemType={type}
          itemKey={`${type}-${stringifyId(id)}`}
          {...restProps}
        >
          <QueueSidebarPoolItem title={title} agentPoolId={id} total={counters?.total || null} />
        </VirtualizedTreeOverlayItem>
      )
    }

    case 'queue-sidebar-link': {
      const {to, title, active} = props.item
      return (
        <VirtualizedTreeItem
          {...props}
          className={classNames(styles.item, styles.hoverableItem, {
            [styles.activeItem]: active,
            [styles.activeTitle]: active,
          })}
          expandable={false}
        >
          <QueueSidebarLinkItem to={to} title={title} />
        </VirtualizedTreeItem>
      )
    }

    default:
      return null
  }
}

export default memo(QueueSidebarItem)
